/**
 * Another clever approach of writing reducers:
 *
 * export default function(state = initialState, action) {
 *   const actions = {
 *      [ACTION_TYPE]: () => [action.payload.data, ...state]
 *   };
 *
 *   return (_.isFunction(actions[action.type])) ? actions[action.type]() : state
 * }
 */

import * as types from '../constants/ActionTypes';
import { assign } from 'lodash';

const initialState = {
  transformation: null,
  details: null
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.SHOW_DETAILS:
      return {transformation: action.transformation, details: action.details, format: action.format};
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/reducers/imageDetails.js
 **/